import { Vector3, Vector3Like } from 'three'

export function cornerPoints(points: Vector3Like[], height: number) {
  const minX = points.reduce((prev, current) => Math.min(current.x, prev), +Infinity)
  const maxX = points.reduce((prev, current) => Math.max(current.x, prev), -Infinity)
  const minY = points.reduce((prev, current) => Math.min(current.y, prev), +Infinity)
  const maxY = points.reduce((prev, current) => Math.max(current.y, prev), -Infinity)

  return {
    handles: [
      new Vector3(minX, minY, height),
      new Vector3(minX, (maxY + minY) / 2, height),
      new Vector3(minX, maxY, height),
      new Vector3((minX + maxX) / 2, maxY, height),
      new Vector3(maxX, maxY, height),
      new Vector3(maxX, (maxY + minY) / 2, height),
      new Vector3(maxX, minY, height),
      new Vector3((minX + maxX) / 2, minY, height),
    ],
    bounding: [
      new Vector3(minX, minY, 0),
      new Vector3(minX, maxY, 0),
      new Vector3(maxX, maxY, 0),
      new Vector3(maxX, minY, 0),
      new Vector3(minX, minY, 0),
    ],
    width: maxX - minX,
    length: maxY - minY,
    extrema: { minX, maxX, minY, maxY },
  }
}
